import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, vModelText as _vModelText, withDirectives as _withDirectives, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, withModifiers as _withModifiers, Teleport as _Teleport, createBlock as _createBlock, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = { class: "rounded bg-white p-3 mb-4" };
const _hoisted_2 = { class: "d-flex justify-content-end" };
const _hoisted_3 = { class: "d-flex flex-wrap" };
const _hoisted_4 = {
    class: "modal fade",
    id: "create",
    tabindex: "-1",
    "aria-labelledby": "createModalLabel",
    "aria-hidden": "true"
};
const _hoisted_5 = { class: "modal-dialog modal-dialog-centered" };
const _hoisted_6 = { class: "modal-content" };
const _hoisted_7 = { class: "modal-body" };
const _hoisted_8 = { class: "form-floating mb-3" };
const _hoisted_9 = { class: "form-floating mb-3" };
const _hoisted_10 = { class: "form-floating mb-3" };
const _hoisted_11 = { class: "form-floating" };
import { FilterMatchMode } from '@primevue/core/api';
import DataTable from "primevue/datatable";
import Column from "primevue/column";
import TenantLayout from '@/Tenant/Layouts/TenantLayout.vue';
import { Head, Link, useForm } from '@inertiajs/vue3';
import { ref } from 'vue';
import { formatters } from '@/Composables/formatters';
import { responseMessages } from '@/Composables/responseMessages';
import { Modal } from 'bootstrap';
export default /*@__PURE__*/ _defineComponent({
    __name: 'Index',
    props: {
        suppliers: Object
    },
    setup(__props) {
        let { showPageFlashMessage, showErrorMessage } = responseMessages();
        let { formatDate } = formatters();
        const props = __props;
        const tableFilter = ref({
            'global': { value: null, matchMode: FilterMatchMode.CONTAINS }
        });
        const createSupplier = useForm({
            name: null,
            address: null,
            contact: null,
            email: null
        });
        function create() {
            createSupplier.submit('post', route('admin.suppliers.store'), {
                preserveScroll: true,
                onSuccess: page => {
                    showPageFlashMessage(page);
                    const modal = Modal.getInstance(document.getElementById('create'));
                    modal.hide();
                },
                onError: errors => {
                    console.log(errors);
                    showErrorMessage(errors[0]);
                }
            });
        }
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock(_Fragment, null, [
                _createVNode(_unref(Head), { title: "Lieferanten" }),
                _createVNode(TenantLayout, null, {
                    default: _withCtx(() => [
                        _cache[10] || (_cache[10] = _createElementVNode("h1", { class: "fw-bold mb-3" }, "Lieferanten", -1)),
                        _createElementVNode("div", _hoisted_1, [
                            _cache[9] || (_cache[9] = _createElementVNode("button", {
                                class: "btn btn-secondary d-inline-flex align-items-center",
                                "data-bs-toggle": "modal",
                                "data-bs-target": "#create"
                            }, [
                                _createElementVNode("svg", {
                                    xmlns: "http://www.w3.org/2000/svg",
                                    width: "16",
                                    height: "16",
                                    fill: "currentColor",
                                    class: "bi bi-plus-lg",
                                    viewBox: "0 0 16 16"
                                }, [
                                    _createElementVNode("path", {
                                        "fill-rule": "evenodd",
                                        d: "M8 2a.5.5 0 0 1 .5.5v5h5a.5.5 0 0 1 0 1h-5v5a.5.5 0 0 1-1 0v-5h-5a.5.5 0 0 1 0-1h5v-5A.5.5 0 0 1 8 2"
                                    })
                                ]),
                                _createElementVNode("span", { class: "ms-2" }, "Neuer Lieferant")
                            ], -1)),
                            _createVNode(_unref(DataTable), {
                                dataKey: "id",
                                value: props.suppliers,
                                stripedRows: "",
                                responsiveLayout: "scroll",
                                globalFilterFields: ['uuid', 'name', 'address', 'contact', 'email', 'createdAt', 'updatedAt'],
                                filters: tableFilter.value,
                                "onUpdate:filters": _cache[1] || (_cache[1] = ($event) => ((tableFilter).value = $event)),
                                paginator: true,
                                rows: 10,
                                paginatorTemplate: "CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown",
                                rowsPerPageOptions: [10, 25, 50, 150],
                                currentPageReportTemplate: "{first} von {last} von insgesamt {totalRecords}"
                            }, {
                                header: _withCtx(() => [
                                    _createElementVNode("div", _hoisted_2, [
                                        _withDirectives(_createElementVNode("input", {
                                            type: "text",
                                            class: "form-control",
                                            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((tableFilter.value['global'].value) = $event)),
                                            placeholder: "Suche",
                                            style: { "width": "250px" }
                                        }, null, 512), [
                                            [_vModelText, tableFilter.value['global'].value]
                                        ])
                                    ])
                                ]),
                                empty: _withCtx(() => [...(_cache[6] || (_cache[6] = [
                                        _createElementVNode("div", { class: "p-3" }, " Keine Einträge gefunden ", -1)
                                    ]))]),
                                loading: _withCtx(() => [...(_cache[7] || (_cache[7] = [
                                        _createTextVNode(" Einträge werden geladen ... ", -1)
                                    ]))]),
                                default: _withCtx(() => [
                                    _createVNode(_unref(Column), {
                                        header: "#",
                                        sortable: true
                                    }, {
                                        body: _withCtx((slotProps) => [
                                            _createTextVNode(_toDisplayString(slotProps.index + 1), 1)
                                        ]),
                                        _: 1
                                    }),
                                    _createVNode(_unref(Column), {
                                        header: "UUID",
                                        field: "uuid",
                                        sortable: true,
                                        sortField: "uuid"
                                    }),
                                    _createVNode(_unref(Column), {
                                        header: "Name",
                                        sortable: true,
                                        sortField: "name"
                                    }, {
                                        body: _withCtx((slotProps) => [
                                            _createVNode(_unref(Link), {
                                                href: _ctx.route('admin.suppliers.edit', slotProps.data.uuid)
                                            }, {
                                                default: _withCtx(() => [
                                                    _createTextVNode(_toDisplayString(slotProps.data.name), 1)
                                                ]),
                                                _: 2
                                            }, 1032, ["href"])
                                        ]),
                                        _: 1
                                    }),
                                    _createVNode(_unref(Column), {
                                        header: "Adresse",
                                        field: "address",
                                        sortable: true,
                                        sortField: "address"
                                    }),
                                    _createVNode(_unref(Column), {
                                        header: "Kontakt",
                                        field: "contact",
                                        sortable: true,
                                        sortField: "contact"
                                    }),
                                    _createVNode(_unref(Column), {
                                        header: "E-Mail",
                                        field: "email",
                                        sortable: true,
                                        sortField: "email"
                                    }),
                                    _createVNode(_unref(Column), {
                                        header: "Letzte Änderung",
                                        sortable: true,
                                        sortField: "updatedAt"
                                    }, {
                                        body: _withCtx((slotProps) => [
                                            _createTextVNode(_toDisplayString(_unref(formatDate)(slotProps.data.updatedAt, true)), 1)
                                        ]),
                                        _: 1
                                    }),
                                    _createVNode(_unref(Column), {
                                        header: "Erstellt",
                                        sortable: true,
                                        sortField: "createdAt"
                                    }, {
                                        body: _withCtx((slotProps) => [
                                            _createTextVNode(_toDisplayString(_unref(formatDate)(slotProps.data.createdAt, true)), 1)
                                        ]),
                                        _: 1
                                    }),
                                    _createVNode(_unref(Column), { header: "" }, {
                                        body: _withCtx((slotProps) => [
                                            _createElementVNode("div", _hoisted_3, [
                                                _createVNode(_unref(Link), {
                                                    href: _ctx.route('admin.suppliers.edit', slotProps.data.uuid),
                                                    class: "btn btn-primary d-inline-flex align-items-center"
                                                }, {
                                                    default: _withCtx(() => [...(_cache[8] || (_cache[8] = [
                                                            _createElementVNode("svg", {
                                                                xmlns: "http://www.w3.org/2000/svg",
                                                                width: "16",
                                                                height: "16",
                                                                fill: "currentColor",
                                                                class: "bi bi-pencil-square text-white",
                                                                viewBox: "0 0 16 16"
                                                            }, [
                                                                _createElementVNode("path", { d: "M15.502 1.94a.5.5 0 0 1 0 .706L14.459 3.69l-2-2L13.502.646a.5.5 0 0 1 .707 0l1.293 1.293zm-1.75 2.456-2-2L4.939 9.21a.5.5 0 0 0-.121.196l-.805 2.414a.25.25 0 0 0 .316.316l2.414-.805a.5.5 0 0 0 .196-.12l6.813-6.814z" }),
                                                                _createElementVNode("path", {
                                                                    "fill-rule": "evenodd",
                                                                    d: "M1 13.5A1.5 1.5 0 0 0 2.5 15h11a1.5 1.5 0 0 0 1.5-1.5v-6a.5.5 0 0 0-1 0v6a.5.5 0 0 1-.5.5h-11a.5.5 0 0 1-.5-.5v-11a.5.5 0 0 1 .5-.5H9a.5.5 0 0 0 0-1H2.5A1.5 1.5 0 0 0 1 2.5z"
                                                                })
                                                            ], -1)
                                                        ]))]),
                                                    _: 1
                                                }, 8, ["href"])
                                            ])
                                        ]),
                                        _: 1
                                    })
                                ]),
                                _: 1
                            }, 8, ["value", "filters"])
                        ])
                    ]),
                    _: 1
                }),
                (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
                    _createElementVNode("div", _hoisted_4, [
                        _createElementVNode("div", _hoisted_5, [
                            _createElementVNode("div", _hoisted_6, [
                                _cache[16] || (_cache[16] = _createElementVNode("div", { class: "modal-header" }, [
                                    _createElementVNode("h1", {
                                        class: "modal-title fs-5 fw-bold",
                                        id: "createModalLabel"
                                    }, "Neuer Lieferant"),
                                    _createElementVNode("button", {
                                        type: "button",
                                        class: "btn-close",
                                        "data-bs-dismiss": "modal",
                                        "aria-label": "Close"
                                    })
                                ], -1)),
                                _createElementVNode("form", {
                                    onSubmit: _withModifiers(create, ["prevent"])
                                }, [
                                    _createElementVNode("div", _hoisted_7, [
                                        _createElementVNode("div", _hoisted_8, [
                                            _withDirectives(_createElementVNode("input", {
                                                type: "text",
                                                class: "form-control",
                                                id: "name",
                                                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => ((_unref(createSupplier).name) = $event)),
                                                required: ""
                                            }, null, 512), [
                                                [_vModelText, _unref(createSupplier).name]
                                            ]),
                                            _cache[11] || (_cache[11] = _createElementVNode("label", { for: "name" }, "Name", -1))
                                        ]),
                                        _createElementVNode("div", _hoisted_9, [
                                            _withDirectives(_createElementVNode("input", {
                                                type: "text",
                                                class: "form-control",
                                                id: "address",
                                                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event) => ((_unref(createSupplier).address) = $event))
                                            }, null, 512), [
                                                [_vModelText, _unref(createSupplier).address]
                                            ]),
                                            _cache[12] || (_cache[12] = _createElementVNode("label", { for: "address" }, "Adresse", -1))
                                        ]),
                                        _createElementVNode("div", _hoisted_10, [
                                            _withDirectives(_createElementVNode("input", {
                                                type: "text",
                                                class: "form-control",
                                                id: "contact",
                                                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event) => ((_unref(createSupplier).contact) = $event))
                                            }, null, 512), [
                                                [_vModelText, _unref(createSupplier).contact]
                                            ]),
                                            _cache[13] || (_cache[13] = _createElementVNode("label", { for: "contact" }, "Kontaktperson", -1))
                                        ]),
                                        _createElementVNode("div", _hoisted_11, [
                                            _withDirectives(_createElementVNode("input", {
                                                type: "email",
                                                class: "form-control",
                                                id: "email",
                                                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event) => ((_unref(createSupplier).email) = $event))
                                            }, null, 512), [
                                                [_vModelText, _unref(createSupplier).email]
                                            ]),
                                            _cache[14] || (_cache[14] = _createElementVNode("label", { for: "email" }, "E-Mail", -1))
                                        ])
                                    ]),
                                    _cache[15] || (_cache[15] = _createElementVNode("div", { class: "modal-footer" }, [
                                        _createElementVNode("button", {
                                            type: "button",
                                            class: "btn btn-secondary",
                                            "data-bs-dismiss": "modal"
                                        }, "Abbrechen"),
                                        _createElementVNode("button", {
                                            type: "submit",
                                            class: "btn btn-success d-inline-flex align-items-center"
                                        }, [
                                            _createElementVNode("svg", {
                                                xmlns: "http://www.w3.org/2000/svg",
                                                width: "16",
                                                height: "16",
                                                fill: "currentColor",
                                                class: "bi bi-check2",
                                                viewBox: "0 0 16 16"
                                            }, [
                                                _createElementVNode("path", { d: "M13.854 3.646a.5.5 0 0 1 0 .708l-7 7a.5.5 0 0 1-.708 0l-3.5-3.5a.5.5 0 1 1 .708-.708L6.5 10.293l6.646-6.647a.5.5 0 0 1 .708 0" })
                                            ]),
                                            _createElementVNode("span", { class: "ms-2" }, "Speichern")
                                        ])
                                    ], -1))
                                ], 32)
                            ])
                        ])
                    ])
                ]))
            ], 64));
        };
    }
});
